import React from 'react';

interface Iprops {
  data?: any
  pClassName?: string
}

function Empty(props: Iprops) {
  const {
    data,
    pClassName
  } = props

  return (
    <>
      {
        data?.link ?
        <div className='overflow-hidden h-[100vh] pb-[80px] flex justify-center items-center'>
          <div className={`p-[32px] w-[584px] rounded-[16px] border-lines shadow-xl bg-white scale-75 2xl:scale-100 3xl:scale-110 ${pClassName}`}>
            <img className=' w-[520px] h-[520px]' src={data?.photo} alt='m2m search'/>
            <div className=' mt-[32px] font-semibold text-xl'>{data?.address}</div>
            <div
                className='text-[#000] mt-[4px] text-2xs line-clamp-3'
                title={`${data.distance} miles away from ${data.location}`}
              >
                  <i className='font-semibold not-italic'>{`${data?.distance}`}</i>
                  <i className='not-italic font-light'> miles away from {data.location || '-'}</i>
            </div>
            <div className='mt-[16px]'>
              {
                data.price ?
                  <div className=' flex flex-wrap'>
                    <div className=' font-semibold text-3lg'>${data?.price}{data.price ? '+' : ''}
                      <i className=' font-normal not-italic'>/</i>
                    </div>
                    <div className=' font-normal text-base'>30 Days</div>
                  </div>
                  :
                  <span className=' font-normal text-base'>Price Not Available</span>
              }
            </div>
          </div>
        </div>
        :
        <div className=' overflow-hidden flex items-center justify-center h-[100vh] flex-col'>
          <img className=' w-[552px] h-[166px]' src={require('../../../img/empty_@2.png')} alt='m2m search'/>
          <div className=' mt-[55px] text-black font-[600] text-3xl'>Month2Month</div>
          <div className=' mt-[22px] text-black'>Month2Month is a housing platform dedicated to providing our guests</div>
          <div className=' text-base text-black'>with fully furnished temporary single-family-homes on flexible lease</div>
          <div className='text-base text-black'>terms starting at 30 days or longer.</div>
          <div className='text-base text-black'>Because we exclusively manage all our homes in our portfolio, our guests</div>
          <div className='text-base text-black'>can expect the very best in comfort and quality.</div>
        </div>
      }
    </>
    
  );
}

export default Empty;
